import { DecimalPipe as AngularDecimalPipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

	/**
	 * @description
	 *	Transforma un número aplicando el formato decimal, en favor del
	 *	existente pipe de Angular con el mismo nombre.
	 */

@Pipe({ name: "real", pure: true })
export class DecimalPipe implements PipeTransform {

	public constructor(private decimalPipe: AngularDecimalPipe) {}

	/**
	 * @description
	 *	Transforma un número en su representación decimal/real.
	 *
	 * @param value
	 *	El número, posiblemente sin especificar.
	 * @param decimals
	 *	La cantidad de decimales fijos a mostrar, por defecto igual que 2.
	 * @param orElse
	 *	Resultado a devolver si el número no fue especificado.
	 *
	 * @returns
	 *	La representación decimal/real del número, o la cadena indicada en el
	 *	parámetro 'orElse', si el número es 'null', 'undefined' o NaN (Not a
	 *	Number).
	 */
	public transform(value: number, decimals: number = 2, orElse: string = "[no disponible]"): string {
		if (value === null || value === undefined || Number.isNaN(value)) {
			return orElse;
		}
		else {
			return this.decimalPipe.transform(value, `1.${decimals}-${decimals}`)
				.replace(/\./g, "_")
				.replace(/,/g, ".")
				.replace(/_/g, ",");
		}
	}
}
